import { inject } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { from, Observable, of } from 'rxjs';
import { switchMap, map, filter, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const publicRoutes = ['/error-page', '/chat/:type/public'];
    if (environment.samlEnabled) {
        publicRoutes.push('/logout-handler');
        publicRoutes.push('/login-admin');
    } else {
        publicRoutes.push('/login');
    }

    if (publicRoutes.some(publicRoute => state.url.includes(publicRoute))) {
        return of(true);
    }

    return authService.isAuthenticated$.pipe(
        filter(isAuthenticated => isAuthenticated !== null),
        take(1),
        switchMap(isAuthenticated => {
            if (isAuthenticated) {
                return from(authService.ensureUserAlignment()).pipe(
                    switchMap(aligned => {
                        if (!aligned) {
                            console.warn('AuthGuard: allineamento utente non riuscito. Reindirizzamento...');
                            return of(router.createUrlTree(['/error-page']));
                        }

                        return authService.getUserInfo().pipe(
                            map(user => {
                                if (user) {
                                    console.log('AuthGuard: Accesso consentito.');
                                    return true;
                                }
                                console.warn('AuthGuard: Utente autenticato ma non trovato nel DB. Reindirizzamento...');
                                return router.createUrlTree(['/error-page']);
                            })
                        );
                    })
                );
            }

            console.log('AuthGuard: Utente non autenticato.');
            if (!environment.samlEnabled) {
                return of(router.createUrlTree(['/login']));
            } else {
                authService.login();
                return of(false);
            }
        })
    );
};